import React from 'react';
import { Outlet } from 'react-router-dom';

const BrandChefsContent = () => {
  return <Outlet />;
};

export default BrandChefsContent;
